import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class RFIDProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_RFID_API)
  }

  paginate (query) {
    this.setHeader(getAuthToken())
    return this.get('/none-display-product/paginate', query)
  }

  getById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/none-display-product/${id}/id`)
  }
}

export default RFIDProvider
